module.exports = __webpack_public_path__ + "img/cropped-Isotipo_Credihome-270x270.01aab359.png";